// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'jcb',
  icon: [
    29,
    19,
    null,
    null,
    null,
    <g id="jcb" fillRule="nonzero" key="jcb">
      <path
        d="M26.58,19 L2.42,19 C1.78347383,19.0053265 1.17090452,18.7575644 0.717061656,18.311223 C0.263218789,17.8648817 0.00528228465,17.2565265 0,16.62 L0,2.38 C0.00528228465,1.74347346 0.263218789,1.13511831 0.717061656,0.688776978 C1.17090452,0.242435646 1.78347383,-0.00532648787 2.42,4.4408921e-16 L26.58,4.4408921e-16 C27.2165262,-0.00532648787 27.8290955,0.242435646 28.2829383,0.688776978 C28.7367812,1.13511831 28.9947177,1.74347346 29,2.38 L29,16.63 C28.9835257,17.9515828 27.9016388,19.0111167 26.58,19 Z"
        id="shape"
        fill="#EBF1F8"
      />
      <path
        d="M5,17 L9,17 C9.91,17 11,15.88 11,15 L11,2 L7,2 C6.09,2 5,3.12 5,5 L5,17 Z"
        id="shape"
        fill="#047AB1"
      />
      <path
        d="M7.27,12.14 C6.50208232,12.1401506 5.73795016,12.0324315 5,11.82 L5,10.72 C5.57265089,11.0740978 6.22721936,11.2739134 6.9,11.3 C7.67,11.3 8.1,10.76 8.1,10.02 L8.1,7 L10,7 L10,10.02 C10,11.2 9.38,12.14 7.27,12.14 Z"
        id="shape"
        fill="#FFFFFF"
      />
      <path
        d="M12,17 L16,17 C16.91,17 18,15.88 18,15 L18,2 L14,2 C13.09,2 12,3.12 12,5 L12,17 Z"
        id="shape"
        fill="#D42D06"
      />
      <path
        d="M12,7.7 C12.58,7.14 13.58,6.79 15.2,6.87 C16.08,6.91 17,7.17 17,7.17 L17,8.28 C16.4738009,7.96174248 15.8823234,7.76686261 15.27,7.71 C14.04,7.6 13.29,8.29 13.29,9.5 C13.29,10.71 14.04,11.4 15.27,11.3 C15.8826962,11.2380635 16.4737868,11.0398944 17,10.72 L17,11.82 C17,11.82 16.08,12.09 15.2,12.13 C13.58,12.21 12.58,11.86 12,11.3 L12,7.7 Z"
        id="shape"
        fill="#FFFFFF"
      />
      <path
        d="M19,17 L23,17 C23.91,17 25,15.88 25,15 L25,2 L21,2 C20.09,2 19,3.12 19,5 L19,17 Z"
        id="shape"
        fill="#67B637"
      />
      <path
        d="M24,10.7 C24,11.5 23.38,12 22.55,12 L19,12 L19,7 L22.23,7 L22.46,7.01 C23.19,7.05 23.73,7.48 23.73,8.22 C23.73,8.8 23.36,9.3 22.69,9.42 L22.69,9.45 C23.43,9.5 24,9.97 24,10.7 L24,10.7 Z M21.45,7.79 C21.4069615,7.78356258 21.3635167,7.78022067 21.32,7.78 L20.12,7.78 L20.12,9.04 L21.45,9.04 C21.7,8.98 21.91,8.75 21.91,8.41 C21.91,8.07 21.7,7.84 21.45,7.79 L21.45,7.79 Z M21.6,9.83 C21.5470944,9.82169217 21.4935284,9.8183443 21.44,9.82 L20.12,9.82 L20.12,11.19 L21.44,11.19 L21.6,11.17 C21.85,11.11 22.06,10.85 22.06,10.5 C22.06,10.15 21.86,9.9 21.6,9.83 Z"
        id="shape"
        fill="#FFFFFF"
      />
    </g>,
  ],
})
